import React from 'react';

const DomesticStudent = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} fill="none" {...props}>
    <path
      fill="#224251"
      d="m16.47 16.168-2.677-.71c.478-.4.813-.89.908-1.511.335-.09.574-.444.574-.889 0-.133-.048-.266-.048-.355l.24-1.733c0-.044.095-.888-.622-1.644-.574-.621-1.578-.932-2.869-.932-1.29 0-2.247.31-2.868.932-.718.711-.622 1.6-.622 1.644l.24 1.733c-.049.089-.049.222-.049.355 0 .444.24.755.574.889.048.622.43 1.155.956 1.555l-2.773.666C6.574 16.479 6 17.234 6 18.123v1.155c0 .133.096.222.239.222H17.761c.143 0 .239-.089.239-.222v-1.155c-.048-.889-.622-1.644-1.53-1.955Zm-7.028-6.53c.526-.534 1.387-.8 2.534-.8 1.147 0 2.008.266 2.486.755.574.578.478 1.288.478 1.288l-.191 1.333c-.048 0-.096-.044-.143-.044l-.24-1.022c0-.089-.143-.178-.239-.178-1.482 0-1.768-.4-1.912-.666.048-.045 0-.133-.048-.178a.243.243 0 0 0-.334 0c-.096.045-.144.133-.192.222-.143.267-.43.667-1.912.667-.096-.045-.191.044-.239.133l-.191 1.022c-.048 0-.096.044-.144.044l-.19-1.333s-.049-.666.477-1.244Zm.287 4.087c0-.134-.096-.223-.239-.223-.239 0-.335-.31-.335-.488s.048-.489.335-.489c.096 0 .191-.089.24-.178l.19-.977c1.339 0 1.77-.31 2.056-.71.287.4.717.71 2.056.755l.191.977c0 .089.143.178.24.178.238 0 .334.31.334.488s-.048.489-.335.489c-.143 0-.239.089-.239.222 0 .666-.478 1.2-1.004 1.6a.374.374 0 0 0-.191.088c-.383.267-.813.4-1.1.4-.239 0-.669-.133-1.052-.355-.047-.045-.095-.045-.143-.09-.526-.399-1.004-.977-1.004-1.687Zm2.247 3.243c-.287 0-.526-.222-.526-.489v-.311c.191.044.383.089.526.089.143 0 .335-.045.526-.089v.311c0 .267-.24.489-.526.489Zm-5.498 1.155c0-.711.43-1.289 1.1-1.555l3.06-.755c.095.044.19.133.334.177v.533c0 .356.24.711.574.845l-1.195 1.688H6.478v-.933Zm4.446.933 1.052-1.466 1.052 1.466h-2.104Zm6.55 0h-3.872l-.622-.867-.621-.866a.94.94 0 0 0 .573-.844v-.533c.144-.044.24-.133.383-.222l2.964.8a1.598 1.598 0 0 1 1.147 1.554v.978h.048Z"
    />
    <path
      fill="#224251"
      d="M10.489 12.507h.489c0 .123.089.206.222.206s.267-.124.267-.206c0-.411-.445-.411-.667-.411-.222 0-.667 0-.667.411 0 .123.09.206.223.206.044 0 .133-.082.133-.206ZM12.521 12.713c.132 0 .22-.082.22-.206h.485c0 .123.088.206.22.206.133 0 .22-.082.22-.206 0-.411-.44-.411-.66-.411-.22 0-.661 0-.661.411-.044.082.044.206.176.206Z"
    />
    <path
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m16.8 7.005-2.304 1.08L12 7.468l-2.4.54-2.4-1.003L12 5l4.8 2.005Z"
    />
    <path
      stroke="#224251"
      strokeLinecap="round"
      strokeWidth={0.5}
      d="M15.429 9.32c0-1.023-1.867-1.543-3.429-1.543-1.561 0-3.428.52-3.428 1.542"
    />
    <path
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.7}
      d="m2 7.498 9.732-5.428a.55.55 0 0 1 .536 0L22 7.498m-2 3.347v8.924c0 .592-.125 1.313-.5 1.731-.375.418-.97.5-1.5.5H6c-.53 0-1.125-.082-1.5-.5S4 20.36 4 19.769v-8.924"
    />
    <path stroke="#224251" strokeLinecap="round" strokeWidth={0.6} d="M4 5.5V2h2.5v1.5" />
  </svg>
);

export default DomesticStudent;
